const getPercentFromPointInRange = (range, point) => {
  const totalDist = range[1] - range[0]
  const distFromStart = point - range[0]

  if (point < range[0]) return 0
  if (point > range[1]) return 1

  return distFromStart / totalDist
}

const getPointFromPercentInRange = (range, percent) => {
  const totalDist = range[1] - range[0]
  return totalDist * percent + range[0]
}

export const getNewPoint = (currY, rScroll, rProp) =>
  getPointFromPercentInRange(rProp, getPercentFromPointInRange(rScroll, currY))

export const aTransform = (currY, rScroll, props) => {
  let cssDef = ""

  props.forEach((prop) => {
    if (prop.name === "opacity") {
      const newPoint = getNewPoint(currY, rScroll, prop.range)
      cssDef += `${newPoint}${prop.unit}`
    } else if (prop.name === "translate3d") {
      const coordinates = []
      prop.ranges.forEach((range, index) => {
        let newPoint = "0"
        if (range !== null) {
          newPoint = getNewPoint(currY, rScroll, range)
        }
        coordinates.push(`${newPoint}${prop.units[index]}`)
      })
      cssDef += `${prop.name}(${coordinates.join()})`
    } else {
      const newPoint = getNewPoint(currY, rScroll, prop.range)
      cssDef += `${prop.name}(${newPoint}${prop.unit}) `
    }
  })

  return cssDef
}

export const injectScrollSnap = (e, w, snapPoints) => {
  const wHeight = w.innerHeight
  const snapDiv = ""
  snapPoints.forEach((i) => {
    const topH = i * wHeight
    const innerC = `scroll-snap-point @ page ${i}, ${parseInt(topH)}px`

    snapDiv += `<div class="text-white italic left-7 absolute" style="scroll-snap-align: start; top: ${topH}px;">${innerC}</div>`
  })

  e.target.lastElementChild.insertAdjacentHTML("afterend", snapDiv)
  e.target.classList.add("scroll-snap-y-proximity")

  return true
}

export const float3d = (i) => (r) =>
  `translate3d(0, ${10 * Math.sin(r + (i * 2 * Math.PI) / 1.6)}px, 0)`

export const getNearestIndexFloor = (arr, num) =>
  arr[
    arr
      .concat(num)
      .sort((a, b) => a - b)
      .indexOf(num) - 1
  ]

export const checkIfAppleDevice = (w) => {
  const navigator = w.navigator
  const ua = navigator.userAgent.toLowerCase()
  const hasMediaCapabilities = !!(
    navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo
  )
  const isSafari =
    ua.indexOf("safari") != -1 &&
    !(ua.indexOf("chrome") != -1) &&
    ua.indexOf("version/") != -1
  return isSafari && hasMediaCapabilities
}

export const checkIfIOS = (w) =>
  /(iPad|iPhone|iPod)/g.test(w.navigator.userAgent)

export const checkIfFirefox = (w) => 
  w.navigator.userAgent.toLowerCase().indexOf('firefox') > -1
